@use '~/theme/theme' as *;
@use '~/theme/typography';

.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: color(lobster-700);
  color: white;
}

.primary {
  background-color: color(violet-600);
}

.sm {
  height: 20px;
  min-width: 20px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 20px;

  @include typography.caption;
  @include typography.semibold;
}

// TODO: review size system (md ed lg) with designer

.md {
  height: 30px;
  min-width: 30px;
  border-radius: 30px;

  @include typography.caption;
  @include typography.semibold;
}

.lg {
  min-width: 40px;
  height: 40px;
  border-radius: 40px;

  @include typography.caption;
  @include typography.semibold;
}
